import { autoserialize, autoserializeAs, inheritSerialization } from 'cerialize';

import { AbstractModel } from '@uzurv/core';

@inheritSerialization(AbstractModel)
export class GeofenceCondition extends AbstractModel {
  @autoserialize
  name: string;

  @autoserialize
  code: string;

  @autoserialize
  description: string;

  static OnSerialized(instance: AbstractModel, json: any): void {
    super.OnSerialized(instance, json);
  }

  static OnDeserialized(instance: AbstractModel, json: any): void {
    super.OnDeserialized(instance, json);
  }
}
